import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LANGUAGE, getStoredLanguage } from './i18n/languagePreference'

const resources = {
    sv: {
        translation: {
            site: {
                title: 'Finance Lab App',
                nav: {
                    menuSection: 'Meny',
                    overview: 'Överblick',
                    issues: 'Emissioner',
                    warrants: 'Teckningsoptioner',
                    convertibles: 'Konvertibler',
                    companies: 'Bolag',
                    advisors: 'Rådgivare',
                    statistics: 'Statistik',
                    news: 'Nyheter',
                    calendar: 'Kalender',
                    reports: 'Rapporter',
                    settingsSection: 'Inställningar',
                    support: 'Support',
                    contact: 'Kontakta oss',
                    help: 'Hjälp',
                    feedback: 'Feedback',
                    adminSection: 'Admin',
                    adminDashboard: 'Dashboard',
                    adminCustomers: 'Kunder',
                    adminUsers: 'Användare',
                    adminPRInput: 'PM Indata',
                    adminPMCompany: 'PM Bolag',
                    adminDelistings: 'Avnoteringar',
                    adminIssues: 'Emissioner',
                    adminIssuesReview: 'Avstämning',
                    adminIssuesNew: 'Ny Emission',
                    adminCompanies: 'Bolag',
                    adminCompaniesNew: 'Nytt Bolag',
                    adminWarrants: 'Teckningsoptioner',
                    adminWarrantsNew: 'Ny Teckningsoption',
                    adminConvertibles: 'Konvertibler',
                    adminConvertiblesNew: 'Ny Konvertibel',
                    adminInvestors: 'Investerare',
                    adminKeywordFilter: 'Keyword Filter',
                    language: 'Språk',
                },
                auth: {
                    loginPrompt: 'Logga in för att fortsätta',
                    login: 'Logga in',
                    logout: 'Logga ut',
                    email: 'E-postadress',
                    password: 'Lösenord',
                    rememberMe: 'Kom ihåg mig',
                    forgotPassword: 'Glömt lösenord?',
                },
                convertibles: {
                    previous: 'Genomförda',
                    current: 'Pågående',
                    future: 'Kommande',
                    detailsTitle: 'Konvertibel {{name}}',
                },
                instruments: {
                    bankruptcy: 'Konkurs',
                    liquidation: 'Likvidation',
                    merger: 'Fusion',
                    acquisition: 'Uppköp',
                    changed_marketplace: 'Byte av marknadsplats',
                    voluntary_delisting: 'Frivillig avnotering',
                    lack_of_compliance: 'Ej uppfyllda noteringskrav',
                    redemption: 'Inlösen',
                },
                issues: {
                    previous: 'Genomförda',
                    current: 'Pågående',
                    future: 'Kommande',
                    detailsTitle: 'Emission {{name}}',
                },
                warrants: {
                    detailsTitle: 'Teckningsoption {{name}}',
                },
                companies: {
                    detailsTitle: 'Bolag: {{name}}',
                },
                advisors: {
                    detailsTitle: 'Rådgivare: {{name}}',
                },
                statistics: {
                    title: 'Statistik',
                },
                overview: {
                    title: 'Överblick',
                    numberOfIssues: 'Antal emissioner',
                    numberOfListedWarrants: 'Antal noterade optioner',
                    ongoingAndUpcoming: 'Pågående och kommande',
                    ongoingAndUpcomingWarrants: 'Pågående och kommande emissioner och teckningsoptioner',
                    last20RightsIssues: 'Senaste 20 företrädesemissioner',
                    numberOfFutureAndOngoingRightsIssues: 'Antal pågående och kommande företrädesemissioner',
                    currentPeriod: 'Aktuell period',
                    oneYearAgo: '1 år sedan',
                    lastAnnouncedIssues: 'Senaste aviserade emissionerna',
                    lastCompletedRightsIssues: 'Senaste avslutade företrädesemissioner',
                },
            },
            entities: {
                issue: {
                    singular: 'Emission',
                    plural: 'Emissioner',
                    fields: {
                        id: 'Id',
                        shareId: 'Aktie',
                        recordDate: 'Avstämningsdag',
                        incRightsDate: 'Datum inkl rätter',
                        exRightsDate: 'Datum exkl rätter',
                        rightsStartDate: 'Rätter start handel',
                        rightsEndDate: 'Rätter slut handel',
                        subStartDate: 'Teckningsperiod start',
                        subEndDate: 'Teckningsperiod slut',
                        ipoTradingDate: 'Första handelsdag',
                        outstandingShares: 'Utestående antal aktier',
                        offeredUnits: 'Erbjudna units',
                        rightsRequired: 'Rätter som krävs',
                        unitsReceived: 'Units som erhålls',
                        sharesInUnit: 'Aktier per unit',
                        unitSubPrice: 'Teckningspris per unit',
                        approxCommitment: 'Åtagande (ca)',
                        approxGuarantor: 'Garanterat (ca)',
                        overAllotmentSize: 'Övertilldelning volym',
                        overAllotmentAllocation: 'Övertilldelning tilldelat',
                        internalComment: 'Intern kommentar',
                        externalComment: 'Extern kommentar',
                        unitSubTotal: 'Units tecknade',
                        unitSubWithRights: 'Units tecknade med rätter',
                        unitSubWithoutRights: 'Units tecknade utan rätter',
                        unitSubGuarantor: 'Units tecknade av garanter',
                        unitGuaranteeFee: 'Units erhållna som arvode',
                        generalMeetingDate: 'Bolagsstämma',
                        isinRights: 'ISIN för rätter',
                        isinUnits: 'ISIN för units',
                        cancelled: 'Avbruten',
                        approxTotalCommitment: 'Totalt åtagande (ca)',
                        sharesRequired: 'Aktier som krävs',
                        rightsReceived: 'Rätter som erhålls',
                        unitPctSubWithRights: 'Units tecknade med rätter (%)',
                        unitPctSubWithoutRights: 'Units tecknade utan rätter (%)',
                        unitPctSubGuarantor: 'Units tecknade av garanter (%)',
                    },
                },
                issueType: {
                    singular: 'Emissionstyp',
                    plural: 'Emissionstyper',
                    values: {
                        'ABB Directed issue': 'Riktad emission (ABB)',
                        'Directed issue': 'Riktad emission',
                        'Guarantor fee issue': 'Garantiersättning',
                        IPO: 'IPO',
                        'Non-cash issue': 'Apportemission',
                        // Other: 'Övrigt',
                        'Rights issue': 'Företrädesemission',
                    },
                },
                warrant: {
                    singular: 'Teckningsoption',
                    plural: 'Teckningsoptioner',
                    fields: {
                        id: 'Id',
                        issueId: 'Emission',
                        name: 'Namn på teckningsoption',
                        subStartDate: 'Teckningsperiod start',
                        subEndDate: 'Teckningsperiod slut',
                        vwapDiscount: 'VWAP rabatt',
                        vwapDays: 'VWAP-beräkning i dagar',
                        vwapPeriodEnd: 'VWAP-beräkning sista datum',
                        numberOfWarrants: 'Minimum teckningskurs',
                        priceMin: 'Minimum teckningskurs',
                        priceMinQuota: 'Kvotvärde minimum teckningskurs',
                        priceMax: 'Maximal teckningskurs',
                        isinWarrant: 'ISIN för teckningsoptionen',
                        warrantsRequired: 'Teckningsoptioner som krävs',
                        sharesReceived: 'Aktier som erhålls',
                        sharesSubscribed: 'Antal tecknade aktier',
                        internalComment: 'Intern kommentar',
                        externalComment: 'Extern kommentar',
                        warrantsPerUnit: 'Teckningsoptioner per unit',
                        commitments: 'Teckningsåtagande',
                        guarantors: 'Garantiåtagande',
                        warrantSubPrice: 'Teckningskurs',
                    },
                },
                company: {
                    singular: 'Bolag',
                    plural: 'Bolag',
                    fields: {
                        id: 'Id',
                        name: 'Namn',
                        ticker: 'Ticker',
                        isin: 'ISIN',
                        website: 'Hemsida',
                        sector: 'Sektor',
                        industry: 'Bransch',
                        description: 'Beskrivning',
                        logo: 'Logotyp',
                    },
                },
                news: {
                    singular: 'Nyhet',
                    plural: 'Nyheter',
                    fields: {
                        id: 'Id',
                        title: 'Rubrik',
                        content: 'Innehåll',
                        date: 'Datum',
                    },
                },
                investor: {
                    singular: 'Investerare',
                    plural: 'Investerare',
                },
                convertible: {
                    singular: 'Konvertibel',
                    plural: 'Konvertibler',
                    fields: {
                        conversion: 'Konvertering',
                        repayment: 'Återbetalning',
                        offset: 'Kvittning',
                        new_loan: 'Upptagning av lån',
                        write_off: 'Nedskrivning',
                    },
                },
            },
        },
    },
    en: {
        translation: {
            site: {
                title: 'Finance Lab App',
                nav: {
                    menuSection: 'Menu',
                    overview: 'Overview',
                    issues: 'Issues',
                    warrants: 'Warrants',
                    convertibles: 'Convertibles',
                    companies: 'Companies',
                    advisors: 'Advisors',
                    statistics: 'Statistics',
                    news: 'News',
                    calendar: 'Calendar',
                    reports: 'Reports',
                    settingsSection: 'Settings',
                    support: 'Support',
                    contact: 'Contact us',
                    help: 'Help',
                    feedback: 'Feedback',
                    adminSection: 'Admin',
                    adminDashboard: 'Dashboard',
                    adminCustomers: 'Customers',
                    adminUsers: 'Users',
                    adminPRInput: 'Press release input',
                    adminPMCompany: 'Press release companies',
                    adminDelistings: 'Delistings',
                    adminIssues: 'Issues',
                    adminIssuesReview: 'Review',
                    adminIssuesNew: 'New issue',
                    adminCompanies: 'Companies',
                    adminCompaniesNew: 'New company',
                    adminWarrants: 'Warrants',
                    adminWarrantsNew: 'New warrant',
                    adminConvertibles: 'Convertibles',
                    adminConvertiblesNew: 'New convertible',
                    adminInvestors: 'Investors',
                    adminKeywordFilter: 'Keyword filter',
                    language: 'Language',
                },
                auth: {
                    loginPrompt: 'Sign in to continue',
                    login: 'Sign in',
                    logout: 'Sign out',
                    email: 'Email address',
                    password: 'Password',
                    rememberMe: 'Remember me',
                    forgotPassword: 'Forgot password?',
                },
                convertibles: {
                    previous: 'Completed',
                    current: 'Ongoing',
                    future: 'Upcoming',
                    detailsTitle: 'Convertible {{name}}',
                },
                instruments: {
                    bankruptcy: 'Bankruptcy',
                    liquidation: 'Liquidation',
                    merger: 'Merger',
                    acquisition: 'Acquisition',
                    changed_marketplace: 'Change of marketplace',
                    voluntary_delisting: 'Voluntary delisting',
                    lack_of_compliance: 'Listing requirements not met',
                    redemption: 'Redemption',
                },
                issues: {
                    previous: 'Completed',
                    current: 'Ongoing',
                    future: 'Upcoming',
                    detailsTitle: 'Issue {{name}}',
                },
                warrants: {
                    detailsTitle: 'Warrant {{name}}',
                },
                companies: {
                    detailsTitle: 'Company: {{name}}',
                },
                advisors: {
                    detailsTitle: 'Advisor: {{name}}',
                },
                statistics: {
                    title: 'Statistics',
                },
                overview: {
                    title: 'Overview',
                    numberOfIssues: 'Number of issues',
                    numberOfListedWarrants: 'Number of listed warrants',
                    ongoingAndUpcoming: 'Ongoing and upcoming',
                    ongoingAndUpcomingWarrants: 'Ongoing and upcoming issues and warrants',
                    last20RightsIssues: 'Latest 20 rights issues',
                    numberOfFutureAndOngoingRightsIssues: 'Number of ongoing and upcoming rights issues',
                    currentPeriod: 'Current period',
                    oneYearAgo: '1 year ago',
                    lastAnnouncedIssues: 'Latest announced issues',
                    lastCompletedRightsIssues: 'Latest completed rights issues',
                },
            },
            entities: {
                issue: {
                    singular: 'Issue',
                    plural: 'Issues',
                    fields: {
                        id: 'Id',
                        shareId: 'Share',
                        recordDate: 'Record date',
                        incRightsDate: 'Date incl. rights',
                        exRightsDate: 'Date excl. rights',
                        rightsStartDate: 'Rights trading start',
                        rightsEndDate: 'Rights trading end',
                        subStartDate: 'Subscription period start',
                        subEndDate: 'Subscription period end',
                        ipoTradingDate: 'First trading day',
                        outstandingShares: 'Outstanding shares',
                        offeredUnits: 'Offered units',
                        rightsRequired: 'Rights required',
                        unitsReceived: 'Units received',
                        sharesInUnit: 'Shares per unit',
                        unitSubPrice: 'Subscription price per unit',
                        approxCommitment: 'Commitment (approx.)',
                        approxGuarantor: 'Guaranteed (approx.)',
                        overAllotmentSize: 'Over-allotment volume',
                        overAllotmentAllocation: 'Over-allotment allocated',
                        internalComment: 'Internal comment',
                        externalComment: 'External comment',
                        unitSubTotal: 'Units subscribed',
                        unitSubWithRights: 'Units subscribed with rights',
                        unitSubWithoutRights: 'Units subscribed without rights',
                        unitSubGuarantor: 'Units subscribed by guarantors',
                        unitGuaranteeFee: 'Units received as fee',
                        generalMeetingDate: 'General meeting',
                        isinRights: 'ISIN for rights',
                        isinUnits: 'ISIN for units',
                        cancelled: 'Cancelled',
                        approxTotalCommitment: 'Total commitment (approx.)',
                        sharesRequired: 'Shares required',
                        rightsReceived: 'Rights received',
                        unitPctSubWithRights: 'Units subscribed with rights (%)',
                        unitPctSubWithoutRights: 'Units subscribed without rights (%)',
                        unitPctSubGuarantor: 'Units subscribed by guarantors (%)',
                    },
                },
                issueType: {
                    singular: 'Issue type',
                    plural: 'Issue types',
                    values: {
                        'ABB Directed issue': 'ABB directed issue',
                        'Directed issue': 'Directed issue',
                        'Guarantor fee issue': 'Guarantor fee issue',
                        IPO: 'IPO',
                        'Non-cash issue': 'Non-cash issue',
                        'Rights issue': 'Rights issue',
                    },
                },
                warrant: {
                    singular: 'Warrant',
                    plural: 'Warrants',
                    fields: {
                        id: 'Id',
                        issueId: 'Issue',
                        name: 'Warrant name',
                        subStartDate: 'Subscription period start',
                        subEndDate: 'Subscription period end',
                        vwapDiscount: 'VWAP discount',
                        vwapDays: 'VWAP calculation days',
                        vwapPeriodEnd: 'VWAP calculation end date',
                        numberOfWarrants: 'Number of warrants',
                        priceMin: 'Minimum subscription price',
                        priceMinQuota: 'Quota value minimum subscription price',
                        priceMax: 'Maximum subscription price',
                        isinWarrant: 'ISIN for warrant',
                        warrantsRequired: 'Warrants required',
                        sharesReceived: 'Shares received',
                        sharesSubscribed: 'Shares subscribed',
                        internalComment: 'Internal comment',
                        externalComment: 'External comment',
                        warrantsPerUnit: 'Warrants per unit',
                        commitments: 'Subscription commitment',
                        guarantors: 'Guarantee commitment',
                        warrantSubPrice: 'Subscription price',
                    },
                },
                company: {
                    singular: 'Company',
                    plural: 'Companies',
                    fields: {
                        id: 'Id',
                        name: 'Name',
                        ticker: 'Ticker',
                        isin: 'ISIN',
                        website: 'Website',
                        sector: 'Sector',
                        industry: 'Industry',
                        description: 'Description',
                        logo: 'Logo',
                    },
                },
                news: {
                    singular: 'News item',
                    plural: 'News',
                    fields: {
                        id: 'Id',
                        title: 'Headline',
                        content: 'Content',
                        date: 'Date',
                    },
                },
                investor: {
                    singular: 'Investor',
                    plural: 'Investors',
                },
                convertible: {
                    singular: 'Convertible',
                    plural: 'Convertibles',
                    fields: {
                        conversion: 'Conversion',
                        repayment: 'Repayment',
                        offset: 'Offset',
                        new_loan: 'New loan',
                        write_off: 'Write-off',
                    },
                },
            },
        },
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: getStoredLanguage() ?? DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
        escapeValue: false,
    },
})
